import CustomIcon from "./Icons/CustomIcon"
import ServiceItem from "./components/ServiceItem"
import FieldContato from "./components/FieldContato"
import NavItem from './components/NavItem';
import Testimonial from "./components/Testimonial"
import test from "./json/testimonial.json"

// Main App Component
const App = () => {
  // State for the contact form

  const handleSubmit = event => {
    event.preventDefault();

    const myForm = event.target;
    const formData = new FormData(myForm);
    var message = formData.get("message")
    var name = formData.get("name")
    const phone = "5575988896585";
    const text = encodeURIComponent(`Olá, meu nome é ${name}. ${message}`);
    const url = `https://wa.me/${phone}?text=${text}`;
    window.open(url, "_blank");
  };


  return (
    <div className="font-sans antialiased text-gray-800 bg-gray-50">
      {/* Header Section */}
      <header className="bg-gradient-to-r from-blue-700 to-blue-900 text-white shadow-lg py-4 px-6 md:px-12 rounded-b-lg">
        <nav className="container mx-auto flex flex-col md:flex-row justify-between items-center">
          <a href="#" className="text-3xl font-bold tracking-wide flex items-center mb-4 md:mb-0">
            <img
              src="./LOGO 3.jpeg"
              alt="Logo Ingredy Bispo Advocacia"
              className="rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out mr-[10px]"
            />
            Ingredy Bispo Advocacia
          </a>
          <ul className="flex flex-wrap justify-center md:space-x-8 text-lg">
            <NavItem section="#home" label="Início" />
            <NavItem section="#about" label="Sobre" />
            <NavItem section="#services" label="Serviços" />
            <NavItem section="#contact" label="Contato" />
            <NavItem section="#testimonials" label="Avaliações" />

          </ul>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="relative bg-cover bg-center h-screen flex items-center justify-center text-center p-6"
        style={{ backgroundColor: "#2563EB" }}>
        <div className="absolute inset-0 bg-blue-900 opacity-70"></div>
        <div className="relative z-10 text-white max-w-4xl mx-auto rounded-lg p-8 bg-black bg-opacity-40">
          <h1 className="text-5xl md:text-7xl font-extrabold leading-tight mb-6 animate-fade-in-down">
            Sua Defesa, Nossa Prioridade.
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-90 animate-fade-in-up">
            Oferecendo soluções jurídicas personalizadas com excelência e dedicação.
          </p>
          <a href="#contact" className="inline-block bg-yellow-400 text-blue-900 font-bold py-3 px-8 rounded-full text-lg hover:bg-yellow-300 transform hover:scale-105 transition duration-300 ease-in-out shadow-lg">
            Agende Sua Consulta
          </a>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-16 bg-white px-6 md:px-12">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
          <div className="md:w-1/2">
            <img
              src="./foto.jpeg"
              alt="Imagem da Ingredy Bispo Advocacia"
              className="rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out"
            />
          </div>
          <div className="md:w-1/2 text-left">
            <h2 className="text-4xl font-bold text-blue-800 mb-6 border-b-4 border-yellow-400 pb-2">Sobre Nós</h2>
            <p className="text-lg leading-relaxed mb-4">
              Ao escolher a INGREDY BISPO ADVOCACIA E CONSULTORIA JURÍDICA, você garante mais do que uma representação legal profissional; você estabelece uma parceria sólida. Desde 2019, nosso escritório de advocacia dedica-se a oferecer expertise e soluções eficientes nas áreas de direito previdenciário e trabalhista, buscando sempre o melhor resultado para cada cliente.
            </p>
            <p className="text-lg leading-relaxed">
              Estamos à disposição para entender suas necessidades e oferecer um atendimento personalizado, pautado na ética e na transparência.
            </p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-16 bg-blue-50 px-6 md:px-12">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl font-bold text-blue-800 mb-12 border-b-4 border-yellow-400 pb-2 inline-block">Advocacia Previdenciária e Trabalhista</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">

            <ServiceItem Nome="Aposentadorias - INSS" Descricao="Orientação e acompanhamento de processos de aposentadoria junto ao INSS.">
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.AposentadoriaIdade />
              </svg>
            </ServiceItem>

            <ServiceItem Nome="Auxílio Doença" Descricao="Assessoria para solicitação e concessão de auxílio-doença.">
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.AuxilioDoenca />
              </svg>
            </ServiceItem>


            <ServiceItem
              Nome="Auxílio Acidente"
              Descricao="Suporte para obtenção do auxílio-acidente por redução da capacidade de trabalho.">
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 96.766 96.767" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.AuxilioAcidente />
              </svg>
            </ServiceItem>

            <ServiceItem
              Nome="Auxílio Reclusão"
              Descricao="Orientação e acompanhamento para concessão do benefício de auxílio-reclusão aos dependentes do segurado preso."
            >
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 392.663 392.663" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.AuxilioReclusao />
              </svg>
            </ServiceItem>

            <ServiceItem
              Nome="Pensão por Morte"
              Descricao="Benefício financeiro destinado aos dependentes de um indivíduo falecido, garantindo suporte e estabilidade financeira após a perda de um ente querido."
            >
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.PensaoMorte />
              </svg>
            </ServiceItem>

            <ServiceItem
              Nome="Salário Maternidade"
              Descricao="Benefício destinado às seguradas que se afastam de suas atividades devido ao nascimento de filho, adoção ou guarda judicial, garantindo suporte financeiro durante o período de licença maternidade."
            >
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.SalarioMaternidade />
              </svg>
            </ServiceItem>

            <ServiceItem
              Nome="BPC - LOAS"
              Descricao="Benefício assistencial concedido a idosos acima de 65 anos ou pessoas com deficiência que comprovem não possuir meios de prover a própria manutenção ou de tê-la provida por sua família."
            >
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.BpcLoas />
              </svg>
            </ServiceItem>

            <ServiceItem
              Nome="Direito Trabalhista"
              Descricao="Orientação e defesa de empregados e empregadores em disputas e ações trabalhistas."
            >
              <svg className="w-16 h-16 mx-auto" fill="currentColor" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <CustomIcon.DireitoTrabalhista />
              </svg>
            </ServiceItem>

          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="py-16 bg-blue-50 px-6 md:px-12">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl font-bold text-blue-800 mb-12 border-b-4 border-yellow-400 pb-2 inline-block">O que nossos clientes dizem</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {
              test.map((e) => {
                return <Testimonial name={e.name} feedback={e.feedback}/>
              })
            }
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 bg-white px-6 md:px-12">
        <div className="container mx-auto text-center">
          <h2 className="text-4xl font-bold text-blue-800 mb-12 border-b-4 border-yellow-400 pb-2 inline-block">Entre em Contato</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div className=" bg-blue-50 p-8 rounded-lg shadow-xl text-left">
              <h3 className="text-2xl font-semibold text-blue-700 mb-6">Fale Conosco</h3>
              <form onSubmit={handleSubmit} netlify="" name="contact" method="POST" className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 text-lg font-medium mb-2">Nome Completo</label>
                  <input
                    type="text"
                    name="name"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Seu nome"
                    required=""
                  />
                </div>
               
                <div>
                  <label htmlFor="message" className="block text-gray-700 text-lg font-medium mb-2">Sua Mensagem</label>
                  <textarea

                    name="message"
                    rows="6"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Descreva brevemente sua questão legal..."
                    required=""
                  ></textarea>

                </div>
                <button
                  type="submit"
                  className="w-full bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-xl hover:bg-blue-800 transition duration-300 ease-in-out transform hover:scale-105 shadow-md"
                >
                  Enviar Mensagem
                </button>
              </form>
            </div>
            <div className=" bg-yellow-50 p-8 rounded-lg shadow-xl text-left">
              <h3 className="text-2xl font-semibold text-blue-700 mb-6">Informações de Contato</h3>
              <FieldContato Nome="WhatsApp" Link="https://wa.me/5575988896585" Valor="(75) 98889-6585" />
              <FieldContato Nome="E-mail" Link="mailto:ingredybispoadv@gmail.com" Valor="ingredybispoadv@gmail.com" />
              <FieldContato Nome="Instagram" Link="https://instagram.com/ingredybispoadv" Valor="@ingredybispoadv" />

              <p className="text-lg text-gray-700 mb-4">
                <strong>Local:</strong> Rua Santo Antônio de Jesus, nº 128, Bairro Quintadinha - CEP: 44.440-436 - Santo Antônio de Jesus, Bahia.
              </p>
              <div className="mt-8">
                {/* Google Maps link or embed can go here */}
                <a href="https://maps.app.goo.gl/2UdyVhMgybg2sn4z8" target="_blank" rel="noopener noreferrer" className="inline-block bg-blue-700 text-white font-bold py-3 px-6 rounded-lg text-lg hover:bg-blue-800 transition duration-300 ease-in-out transform hover:scale-105 shadow-md">
                  Ver no Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Footer Section */}
      <footer className="bg-gray-800 text-white py-8 px-6 md:px-12 rounded-t-lg">
        <div className="container mx-auto text-center">
          <p className="text-lg mb-4">&copy; {new Date().getFullYear()} Ingredy Bispo Advocacia. Todos os direitos reservados.</p>
          <div className="flex justify-center space-x-6">
            <a href="https://wa.me/5575988896585" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition duration-300">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <CustomIcon.WhatsApp />

              </svg>
            </a>
            <a href="https://instagram.com/ingredybispoadv" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition duration-300">
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <CustomIcon.Instagram />
              </svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;

